<template>
  <div class="table">
    <div class="crumbs">
      <el-breadcrumb separator="/">
        <el-breadcrumb-item>
          <i class="el-icon-lx-cascades"></i> 防沉迷链接
        </el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <div class="container">
      <div class="app-container">
        <div style="margin-bottom: 20px">
          <div>
           <span>游戏名称：</span>
           <el-select v-model="listQuery.game_id" filterable  placeholder="请选择">
              <el-option
                v-for="item in gameNameOptions"
                :key="item.index"
                :label="item.name"
                :value="item.id"
                >
              </el-option>
            </el-select>
          <span style="font-size:15px;margin-left:20px;">系统：</span>
          <el-select v-model="listQuery.operation_system" filterable placeholder="请选择">
            <el-option
              v-for="item in systemOptions"
              :key="item.value"
              :label="item.name"
              :value="item.id">
            </el-option>
          </el-select>
          <span style="font-size:15px;margin-left:20px;">互通/不互通：</span>
          <el-select v-model="listQuery.is_apply" filterable placeholder="请选择">
            <el-option
              v-for="item in interflowOptions"
              :key="item.value"
              :label="item.name"
              :value="item.id">
            </el-option>
          </el-select>
          <span style="margin-left:20px;">时间：</span>
          <el-date-picker
            v-model="listQuery.created_at"
            type="datetimerange"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            value-format="yyyy-MM-dd HH:mm:ss"
            :default-time="['24:00:00']"
          ></el-date-picker>
          </div>
          <div style="float:right; margin:30px 30px 20px 0;">
             <el-button
                  class="filter-item"
                  style="margin-left: 10px;"
                  type="primary"
                  icon="el-icon-search"
                  @click="search"
          >搜索</el-button>
             <el-button
                  v-if ="store_button"
                  class="filter-item"
                  style="margin-left: 10px;"
                  type="success"
                  @click="addLink"
          >添加</el-button>
          <el-button
                  class="filter-item"
                  style="margin-left: 10px;"
                  type="warning"
                  @click="resetAll"
          >重置</el-button>
          </div>
        </div>
        <el-table border 
         min-height="200"  max-height="1000" 
        v-loading="listLoading" 
        :data="tableData"
         style="width: 100%" 
         >
            <el-table-column prop="operation_system" label="系统"   width="100"/>
            <el-table-column prop="game_name" label="游戏名称" width="150"  :show-overflow-tooltip="true"/>
            <el-table-column prop="game_package" label="游戏包名" width="150"  :show-overflow-tooltip="true" />
            <el-table-column prop="main_game_name" label="主游戏名称" width="150"  :show-overflow-tooltip="true" v-if="main_game_permission" />
            <el-table-column prop="is_apply" label="互通/不互通"  width="100" />
            <el-table-column prop="app_key" label="appkey" width="100" />
            <el-table-column prop="game_link" label="链接"  width="150"  :show-overflow-tooltip="true" />
            <el-table-column prop="admin_name" label="添加人" width="100" />
            <el-table-column prop="updated_at" label="时间" width="150" />
            <el-table-column prop="remark" label="备注" width="150"  :show-overflow-tooltip="true"/>
            <el-table-column label="操作"  fixed="right" >
              <template slot-scope="scope">
                <el-button size="mini" type="success" :data-clipboard-text="scope.row.game_link" @click="copyLink(scope.row)" class="link">复制</el-button>
                <el-button size="mini" type="warning" icon="el-icon-edit" @click="fixData(scope.row)" v-if="update_button">修改</el-button>
                <el-button size="mini" type="primary" @click="historyRcords(scope.row)"  v-if="logs_button">历史记录</el-button>
                <el-button size="mini" type="warning" @click="addRemarks(scope.row)"  >添加备注</el-button>
                <el-button size="mini" icon="el-icon-delete" type="danger" @click="deleteLink(scope.row)" v-if="destroy_button">删除</el-button>
              </template>
            </el-table-column>
        </el-table>

        <el-dialog :title="popupTitle" width="60%"  center :visible.sync="linkShow" class="billHandle"
        v-loading="listLoading" :close-on-click-modal= addControl @close='closeDialog'
        >
          <el-form style="margin-left:40px;" >
            <el-form-item label="系统" :label-width="formInputWidth">
              <el-col :span="8">
                <el-select  filterable v-model="formData.operation_system" placeholder="请选择" >
                  <el-option
                    v-for="item in systemOptions"
                    :key="item.index"
                    :label="item.name"
                    :value="item.id">
                  </el-option>
                </el-select>
              </el-col>
            </el-form-item>
            <el-form-item label="游戏名称" :label-width="formInputWidth" >
              <el-col :span="8" >
                <el-select  filterable v-model="formData.game_id" placeholder="请选择" >
                  <el-option
                    v-for="item in gameNameOptions"
                    :key="item.index"
                    :label="item.name"
                    :value="item.id">
                  </el-option>
                </el-select>
              </el-col>
            </el-form-item>
            <el-form-item label="游戏包名" :label-width="formInputWidth">
              <el-col :span="8">
                <el-input  v-model="formData.game_package" ></el-input>
              </el-col>
            </el-form-item>
            <el-form-item label="主游戏名称" :label-width="formInputWidth" v-if="main_game_permission">
              <el-col :span="8">
                <el-input   v-model="formData.main_game_name"></el-input>
              </el-col>
            </el-form-item>
            <el-form-item label="互通/不互通" :label-width="formInputWidth">
              <el-col :span="8">
                  <el-select  filterable v-model="formData.is_apply" placeholder="请选择" >
                    <el-option
                        v-for="item in interflowOptions"
                        :key="item.index"
                        :label="item.name"
                        :value="item.id">
                    </el-option>
                </el-select>
  
              </el-col>
            </el-form-item>
            <el-form-item label="appkey" :label-width="formInputWidth">
              <el-col :span="8">
                <el-input v-model="formData.app_key" ></el-input>
              </el-col>
            </el-form-item>
            <el-form-item label="链接" :label-width="formInputWidth">
              <el-col :span="8">
                <el-input  v-model="formData.game_link" 
                ></el-input>
              </el-col>
            </el-form-item>

            <el-form-item label="备注" :label-width="formInputWidth">
              <el-col :span="16">
                <el-input type="textarea" v-model="formData.remark" :rows="6" ></el-input>
              </el-col>
            </el-form-item>
          </el-form>
           <div slot="footer" class="dialog-footer">
            <el-button @click="removeLink">取 消</el-button>
            <el-button type="primary" @click="sureLink">确认</el-button>
           </div>
          </el-dialog>

        <el-dialog title="添加备注" width="40%"  center :visible.sync="remarkShow" class="billHandle">
          <el-form  style="margin-left:-160px;" >
            <el-form-item label="备注" :label-width="formInputWidth">
              <el-col :span="16">
                <el-input type="textarea" v-model="remark.content" :rows="6"> </el-input>
              </el-col>
            </el-form-item>
          </el-form>
          <el-table :data="remark.tableLogData"  v-loading="remarkLoading"  style="width: 100%" >
            <el-table-column prop="created_at" label="时间"/>
            <el-table-column prop="admin_name" label="操作人"  />
            <el-table-column prop="remark" label="备注"  :show-overflow-tooltip="true" />
          </el-table>
          <div slot="footer" class="dialog-footer">
            <el-button @click="remarkShow = false">取 消</el-button>
            <el-button type="primary" @click="sureRemark">确认</el-button>
          </div>
        </el-dialog>

        <el-dialog title="删除" width="40%"  center :visible.sync="deleteShow" class="billHandle">
        <p>确认删除此防沉迷链接？</p>
         <div slot="footer" class="dialog-footer">
            <el-button @click="deleteShow = false">取 消</el-button>
            <el-button type="primary" @click="sureDelete">确认</el-button>
          </div>
        </el-dialog>

        <pagination
          v-show="total>0"
          :total="total"
          :page.sync="listQuery.page"
          :limit.sync="listQuery.limit"
          @pagination="linkList"
        />
      </div>
    </div>
  </div>
</template>

<script>
import {
    linkListApi,
    getLinkSelectApi,
    addLinkApi,
    getFixApi,
    putFixApi,
    deleteLinkApi,
    viewRemarkApi,
    putRemarkApi,
} from "@/api/indulge_link.js";
import Clipboard from 'clipboard';
import Pagination from "@/components/pagination/index";
    export default {
        components: { Pagination },
        name: "indulge_link",
        data() {
        return {
            listQuery:{
                game_id:"",
                operation_system:"",
                is_apply:"",
                created_at:[],
                limit:50,
                page:1
            },
            gameNameOptions:[],
            systemOptions:[],
            interflowOptions:[],
            linkShow:false,
            main_game_permission:false,

            formData:{
                operation_system:"",
                game_id:"",
                game_package:"",
                is_apply:"",
                app_key:"",
                game_link:"",
                remark:"",
                main_game_name:"",
            },
            tableData: [],
            popupTitle:"",
            total: 0,
            delteID:"",
            operateCheck:"",
            fixID:"",

            // 添加数据的缓存。
            addData:{},
            addCheck:0,

            // 按钮权限的控制。
            store_button:"",
            update_button:"",
            destroy_button:"",
            logs_button:"",

            // 备注
            remarkShow:false,
            remarkLoading:false,
            remarkID:"",
            remark:{
              content:"",
              tableLogData:[]
            },
            deleteShow:false,
            listLoading: false,
            filterable:true,
            formInputWidth: "200px",
        };
    },
    computed:{
    addControl(){
      let item = true;
      if(this.popupTitle  == "添加"){
        item = false;
      }
      return item;
    }
  },
     mounted() {
          this.linkList();
          getLinkSelectApi()
           .then(response =>{
             this.gameNameOptions = response.data.data.game;
             this.systemOptions = response.data.data.system;
             this.interflowOptions = response.data.data.apply;
           })
           .catch(error=>{

           })
          this.$nextTick(() => {
            this.clipboard = new Clipboard('.link');
          })
        },
    methods: {
      linkList(){
        this.listLoading = true;
        linkListApi(this.listQuery)
         .then(response =>{
             let array = [];
              for(let item of response.data.data.data){
                  if(item.is_apply == 1){
                    item.is_apply = "互通"
                  }
                  else if(item.is_apply == 2){
                    item.is_apply = "不互通"
                  }
                  array.push(item)
              }
            this.tableData = array;
            this.listQuery.page = response.data.data.current_page;
            this.total = response.data.data.total;
            this.store_button = response.data.data.store_button;
            this.update_button = response.data.data.update_button;
            this.destroy_button = response.data.data.destroy_button;
            this.logs_button = response.data.data.logs_button;
            this.main_game_permission = response.data.data.main_game_permission;
            this.listLoading = false;
         })
         .catch(error=>{})
      },
    addLink(){
        this.popupTitle = "添加";
        this.operateCheck = 1;
        for(let key in this.formData){
          this.formData[key] = "";
        }
        if(this.addCheck == 1){
          this.formData = JSON.parse(JSON.stringify(this.addData));
        }
        this.linkShow = true;
    },
     closeDialog(){
        if(this.popupTitle  == "添加" && (this.addCheck == 0 || this.addCheck == 1)){
           this.addData = JSON.parse(JSON.stringify(this.formData));
           this.addCheck = 1;
        }
        if(this.popupTitle  == "添加" && this.addCheck == 2){
             this.addCheck = 0;
             this.addData = {};
        }
      },
    removeLink(){
      this.linkShow = false;
    },
    sureLink(){
      if(this.operateCheck == 1){ // 添加
          let data = JSON.parse(JSON.stringify(this.formData))
          addLinkApi(data)
           .then(response =>{
              if(response.data.code == 200){
                this.$message.success(response.data.message);
                this.addCheck = 2;
                this.linkList();
              }else{
                this.$message.error(response.data.message);
              }
              this.linkShow = false;
           })
           .catch(error=>{})
      }
      else if(this.operateCheck == 0) { // 修改
          let data = JSON.parse(JSON.stringify(this.formData));
          data.id = this.fixID;
          putFixApi(data)
           .then(response =>{
              if(response.data.code == 200){
                  this.$message.success(response.data.message);
                  this.linkList();
              }else{
                  this.$message.error(response.data.message);
              }
              this.linkShow = false;
           })
           .catch(error=>{})
      }
    },
      search(){
        this.listQuery.page = 1;
        this.linkList();
      },
      resetAll(){
        this.listQuery.game_id = "";
        this.listQuery.operation_system = "";
        this.listQuery.is_apply = "";
        this.listQuery.created_at = [];
        this.listQuery.limit = 50;
        this.listQuery.page = 1;
        this.linkList();
      },
      copyLink(){
        this.$message.success("你已成功复制防沉迷链接");
      },
      fixData(item){
        this.popupTitle = "修改";
        this.fixID = item.id;
        this.operateCheck = 0;
        let data ={};
        data.id = this.fixID;
        getFixApi(data)
         .then(response =>{
           this.formData = JSON.parse(JSON.stringify(response.data.data));
         })
         .catch(error=>{})
        this.linkShow = true;
      },
      historyRcords(item){
          let data ={};
          data.id = item.id;
          data = JSON.stringify(data);
          this.$router.push({path:'/dpartmentSmmary_linkHistory',query: { data }});
      },
      addRemarks(item){
        this.remark.content = item.remark;
        this.remarkID = item.id;
        let data = {};
        data.id = this.remarkID;
        this.remarkLoading = true;
        viewRemarkApi(data)
         .then(response =>{
           this.remark.tableLogData = response.data.data.data;
           this.remarkLoading = false;
         })
         .catch(error=>{
           this.remarkLoading = false;
         })
        this.remarkShow = true;
      },
      sureRemark(){
        let data = {}
        data.id = this.remarkID;
        data.remark = this.remark.content;
        putRemarkApi(data)
         .then(response =>{
            if(response.data.code == 200){
              this.$message.success(response.data.message);
              this.linkList();
            }else{
              this.$message.error(response.data.message);
            }
         })
         .catch(error=>{})
        this.remarkShow = false;
      },
      deleteLink(item){
        this.delteID = item.id;
        this.deleteShow = true;
      },
      sureDelete(){
        let data = {};
        data.id = this.delteID;
        deleteLinkApi(data)
         .then(response =>{
            if(response.data.code == 200){
              this.$message.success(response.data.message);
              this.linkList();
            }else{
              this.$message.error(response.data.message);
            }
         })
         .catch(error=>{})
        this.deleteShow = false;
      },
    }
};
</script>
<style >
div.el-transfer .el-transfer-panel {
  width: 400px;
}
</style>
